const phone = "0502000787";
export default phone;
